export const oauthConsent = {
  title: 'Autorizar acceso',
  subtitle: 'quiere conectarse a tu cuenta de Referent',
  genericClient: 'Una aplicación',
  loginPrompt: 'Iniciá sesión para continuar con la autorización de la conexión.',
  scopesTitle: 'Esto le permitirá a la aplicación:',
  scopes: {
    'mcp:read': 'Leer el contenido, planes y publicaciones de tu organización',
    'mcp:write': 'Crear y actualizar contenido y publicaciones',
    offline_access: 'Mantenerse conectada sin pedirte iniciar sesión de nuevo',
    openid: 'Verificar tu identidad',
    profile: 'Acceder a la información básica de tu perfil',
    email: 'Acceder a tu dirección de correo',
  },
  unknownScope: 'Acceso: {{scope}}',
  approve: 'Permitir',
  reject: 'Rechazar',
  approving: 'Autorizando…',
  connectedAs: 'Sesión iniciada como {{email}}',
  missingCode: 'Este enlace de autorización es inválido o expiró. Volvé a iniciar la conexión.',
  approveError: 'No se pudo completar la autorización. Intentá de nuevo.',
  rejected: 'Autorización rechazada.',
  emailRequired: 'El correo es obligatorio',
  passwordRequired: 'La contraseña es obligatoria',
  showPassword: 'Mostrar contraseña',
  hidePassword: 'Ocultar contraseña',
} as const
